import { Injectable } from "@angular/core";
import { Adapter } from "../../../records/classes/adapter";
import { InterviewSummary } from "./interview-summary";

@Injectable({ providedIn: "root" })
export class InterviewAdapter extends Adapter<InterviewSummary, any> {
  toView(rawData: any): InterviewSummary {
    // Qui "normalizzi" i vari possibili nomi in un’unica property "surveyRequestId"
    return new InterviewSummary({
      ...rawData,
      surveyRequestId: 
        rawData.surveyRequestId ??
        rawData.SurveyRequestId ??
        rawData.SurveyRequestID ??
        ''
    });
  }
}
